var $ = require("jquery");
require("jquery.marquee");

import iFrameResizer from "iframe-resizer/js/iframeResizer";

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
import 'swiper/css/bundle';

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import Player from '@vimeo/player';

import 'sticky-kit/dist/sticky-kit.js';
//import SplitType from 'split-type';

	var windowWidth = $(window).width()
	var windowHeight = window.innerHeight;

/* ====================== Custom Cookiebot Close Button ======================  */
	document.addEventListener('DOMContentLoaded', function () {
		// Wait for Cookiebot to render
		var observer = new MutationObserver(function () {
			var detailPanel = document.getElementById('CybotCookiebotDialog');

			if (detailPanel && !document.getElementById('custom-cb-close')) {
			var closeBtn = document.createElement('button');
			closeBtn.id = 'custom-cb-close';
			closeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16.263" height="16.264" viewBox="0 0 16.263 16.264">
				<g id="Group_4031" data-name="Group 4031" transform="translate(8.132 -6.01) rotate(45)">
					<line id="Line_113" data-name="Line 113" x2="20" transform="translate(0 10)" fill="none" stroke="#2e2b29" stroke-width="2"/>
					<line id="Line_114" data-name="Line 114" y2="20" transform="translate(10 0)" fill="none" stroke="#2e2b29" stroke-width="2"/>
				</g>
			</svg>`;
			closeBtn.setAttribute('aria-label', 'Close cookie settings');

			closeBtn.addEventListener('click', function () {
				if (typeof Cookiebot !== 'undefined') {
				Cookiebot.hide();
				}
			});

			detailPanel.appendChild(closeBtn);
			}
		});

		observer.observe(document.body, { childList: true, subtree: true });
		});

jQuery(document).ready(function($) {
	if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) && window.innerHeight > window.innerWidth) {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', vh+'px');
		document.documentElement.style.setProperty('--staticvh', vh+"px");
		window.addEventListener('resize', function() {
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', vh+'px');
	});
	}

/* ====================== Homepage Hero ======================  */
const homepageHero = new Swiper('.homepage-hero .background-carousel', {
	slidesPerView: 1,
	speed: 2000,
	loop: true,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	autoplay: {
		delay: 5000,
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	  },
});

/* ====================== Homepage Masthead ======================  */
$('.homepage-hero .btn').hover(function(){
	$(this).parent('.content').toggleClass('btn-hovered');
});

Fancybox.bind("[data-fancybox]", {

});

/* ====================== Snackbar ======================  */
	if(windowWidth < 1023) {
		$('.snackbar .wrap').marquee({
			duration: 15000,
			duplicated: true,
			gap: 50,
			startVisible: true
		});
	}

/* ====================== GSAP ANIMATIONS ======================  */
	ScrollTrigger.config({ ignoreMobileResize: true });

	let animate = gsap.utils.toArray('.animate');
	animate.forEach((item) => {
		gsap.timeline({
			scrollTrigger: {
				trigger: item,
				start: "top 90%",
				markers: false,
				once: true,
				toggleClass: 'animateelement'
			}
		});
	});

/* ====================== Cookiebot ======================  */
$('.update-cookie-consent').on("click", function(e) {
	e.preventDefault();
	Cookiebot.renew();
});

/* ====================== Semi Sticky Nav ======================  */
	var prevScrollpos = window.pageYOffset;
	var currentScrollPos = window.pageYOffset;

	if(currentScrollPos > 200) {
		$("header").addClass("headerscrolled");
	}

	window.onscroll = function() {
		var currentScrollPos = window.pageYOffset;

		if ((prevScrollpos > currentScrollPos)) {
			$('header').addClass('show');
		} else if((prevScrollpos < currentScrollPos)){
			$('header').removeClass('show');
		}
		else {
			$('header').removeClass('show');
		}

		if(currentScrollPos > 150) {
			$("header").addClass("headerscrolled");
		} else {
			$("header").removeClass("headerscrolled show");

			if (currentScrollPos < prevScrollpos) {
				if(windowWidth < 1024) {
					$('nav').each(function() {
						this.scrollLeft = 0;
					});
				}
			}
		}

		prevScrollpos = currentScrollPos;
	}

/* ====================== MEGA MENU ======================  */

        function openMegaMenu(lockScroll) {
            $('#menu-main-menu > li.mega-menu-trigger').addClass('active');
            $('.mega-menu').addClass('active');
            if (lockScroll) $('body').addClass('noscroll');
            $('.mega-menu .tab[data-related=venue]').addClass('active');
            $('.mega-menu .inner-menu[data-related=venue]').addClass('active');
        }

        function closeMegaMenu(lockScroll) {
            $('#menu-main-menu > li.mega-menu-trigger').removeClass('active');
            $('.mega-menu').removeClass('active');
            if (lockScroll) $('body').removeClass('noscroll');
            setTimeout(function() {
                $('.mega-menu .tab, .mega-menu .inner-menu').removeClass('active');
            }, 400);
        }

        if (windowWidth > 1279) {
            // Hover: no scroll lock — prevents scrollbar appearing/disappearing and causing layout shift
            $('#menu-main-menu > li.mega-menu-trigger').on('mouseenter', function() {
                openMegaMenu(false);
            });

            $('#menu-main-menu > li.mega-menu-trigger, .mega-menu').on('mouseleave', function(e) {
                var to = e.relatedTarget;
                if (!$(to).closest('.mega-menu').length && !$(to).closest('#menu-main-menu > li.mega-menu-trigger').length) {
                    closeMegaMenu(false);
                }
            });
        } else {
            $('#menu-main-menu > li.mega-menu-trigger').on('click', function(event) {
                event.preventDefault();
                event.stopPropagation();

                if ($(this).hasClass('active')) {
                    closeMegaMenu(true);
                    $(document).off('click.megaMenuClose');
                } else {
                    openMegaMenu(true);

                    setTimeout(function() {
                        $(document).on('click.megaMenuClose', function(e) {
                            if (
                                $('.mega-menu').hasClass('active')
                                && !$(e.target).closest('.mega-menu').length
                                && !$(e.target).closest('#menu-main-menu > li.mega-menu-trigger').length
                            ) {
                                closeMegaMenu(true);
                                $(document).off('click.megaMenuClose');
                            }
                        });
                    }, 10);
                }
            });
        }

		// Measure Scrollbar
		function getScrollbarWidth() {
			return window.innerWidth - document.documentElement.clientWidth;
		}

        function positionMegaMenu() {
            var menuPosition = $('#menu-main-menu > li.mega-menu-trigger').offset();
            if (menuPosition) {
				var scrollbarWidth = getScrollbarWidth();
				var left = menuPosition.left - 23 + 'px';
                $('.mega-menu').css('left', left);
            }
        }

        if(windowWidth > 1023) {
            positionMegaMenu();

            $(window).on('resize', function() {
                positionMegaMenu();
            });
        }

        $('.mega-menu .tab:not(.venues-link)').on("click", function() {
			if($(this).hasClass('active')) {
				return;
			}

            $('.mega-menu .tab').removeClass('active');
			$('.mega-menu .inner-menu').removeClass('active');

            var data_related = $(this).attr('data-related');
            $(this).addClass('active');
			$('.mega-menu .inner-menu[data-related=' + data_related + ']').addClass('active');
        })

	if(windowWidth < 768) {
		var i = 0;
		$( ".key-features .feature" ).each(function( index ) {
		  	if(i == 3){
		  		i = 0;
		  	}

		  	$(this).css('order', i);

		  	i++;
		});
	}

/* ====================== Venue Videos Mobile Carousel ======================  */
	if(windowWidth < 768) {
		const mobileVideos = new Swiper('.mobile-videos, .mobile-gallery-strip-container', {
			spaceBetween: 15,
		   	slidesPerView: "1.1",
		   	speed: 600,
		   	centeredSlides: true,
		   	loop: false,
		   	breakpoints: {
				767: {
					slidesPerView: "2.1",
					spaceBetween: 20,
				},
			}
		});
	}

/* ====================== Special Offers Mobile Carousel ======================  */
	if(windowWidth < 1024) {
		const projectsCarousel = new Swiper('.mobile-carousel .swiper', {
			spaceBetween: 15,
		   	slidesPerView: "1.1",
		   	speed: 600,
		   	centeredSlides: true,
		   	loop: false,
		   	breakpoints: {
				767: {
					slidesPerView: "2.1",
					spaceBetween: 20,
				},
			}
		});
	}


/* ====================== Venue Card Mobile Carousel ======================  */
	if(windowWidth < 768) {
		const galleryCarousel = new Swiper('.gallery .swiper', {
		   	slidesPerView: "1",
		   	speed: 600,
		   	loop: true,
		   	pagination: {
				el: ".gallery .swiper-pagination",
				clickable: true,
	  		},
		});
	}

/* ====================== Portfolio Carousel ======================  */
	const mq = window.matchMedia('(min-width: 767px)');
	const $progress = $('.portfolio .carousel-nav-container .progress');

	const portfolioCarousel = new Swiper('.portfolio:not(.wedding-ideas) .swiper', {
		spaceBetween: 20,
		slidesPerView: 1.2,
		speed: 600,
		centeredSlides: true,
		loop: true,
		autoplay: mq.matches ? { delay: 10000 } : false,
		loopAdditionalSlides: 3,
		navigation: {
			nextEl: ".portfolio:not(.wedding-ideas) .swiper-button-next",
			prevEl: ".portfolio:not(.wedding-ideas) .swiper-button-prev",
		},
		breakpoints: {
			767: {
				slidesPerView: 3,
				spaceBetween: 42,
				initialSlide: 1,
			},
		},
		on: {
			init() {
				$progress.addClass('active');
			},
			slideChangeTransitionStart() {
				$progress.removeClass('active');
			},
			slideChangeTransitionEnd() {
				$progress.addClass('active');
			},
		},
	});

	/* ====================== Portfolio Carousel ======================  */
	const weddingIdeasCarousel = new Swiper('.portfolio.wedding-ideas .swiper', {
		spaceBetween: 20,
		slidesPerView: 1.2,
		speed: 600,
		centeredSlides: true,
		loop: false,
		breakpoints: {
			767: {
				slidesPerView: 3,
				spaceBetween: 42,
			},
		}
	});
/* ====================== Full Width Image Carousel ======================  */
	const fullWidthImagecarousel = new Swiper('.full-width-image-carousel .swiper', {
		spaceBetween: 20,
		slidesPerView: 1.2,
		speed: 600,
		centeredSlides: true,
		loop: true,
		navigation: {
			nextEl: ".full-width-image-carousel .swiper-button-next",
			prevEl: ".full-width-image-carousel .swiper-button-prev",
		},
		breakpoints: {
			767: {
				slidesPerView: 1.5,
			},
		}
	});

/* ====================== Accordion ======================  */
	//$('.accordion .accordion-row:first-of-type .accordion-row-intro').addClass('active');
	//$('.accordion .accordion-row:first-of-type .accordion-row-content').slideDown();
	//$('.accordion .accordion-row:first-of-type .accordion-row-content').addClass('active');

	$('.accordion .accordion-row-intro').on('click', function () {
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).next('.accordion-row-content').slideUp();
			$(this).next('.accordion-row-content').removeClass('active');
		} else {
			$('.accordion .accordion-row-intro').removeClass('active');
			$('.accordion-row-content').slideUp();
			$('.accordion-row-content').removeClass('active');

			$(this).addClass('active');
			$(this).next('.accordion-row-content').slideDown();
			$(this).next('.accordion-row-content').addClass('active');
		}
	});


/* ====================== Venue Gallery ======================  */
	var swiper = new Swiper(".navigation", {
		spaceBetween: 10,
		slidesPerView: 3,
		freeMode: true,
		watchSlidesProgress: true,
		navigation: {
			nextEl: ".navigation-container .swiper-button-next",
			prevEl: ".navigation-container .swiper-button-prev",
		},
		breakpoints: {
			767: {
				slidesPerView: 6,
				spaceBetween: 10,
			},
		}
	});

	var swiper2 = new Swiper(".main-image", {
	  spaceBetween: 20,
	  slidesPerView: 1,
	  thumbs: {
	  	swiper: swiper,
	  },
	});

/* ====================== Reveal Content ======================  */
	$('div.show-more').on("click", function() {
		$(this).toggleClass('active');
		$(this).parent().find('.hidden-content').slideToggle();

		if($(this).hasClass('active')) {
			$(this).find('span').html('less');
		} else {
			$(this).find('span').html('more');
		}
	})

/* ====================== Map Interaction ======================  */
	$('.map-marker').on("mouseover", function () {
		$('.map-marker').removeClass('hovered');
		$('.venue-card').removeClass('hover-highlighted');
		var venue_related = $(this).attr('venue-related');
		var location_related = $(this).attr('location-related');

		$(this).addClass('hovered');
		$('.location[location-related=' + location_related + ']').addClass('active');
		$('.venue-card[venue-related=' + venue_related + ']').addClass('hover-highlighted');

		setTimeout(
		function() {
			$('.venue-card[venue-related=' + venue_related + ']').removeClass('hover-highlighted');
			$(this).removeClass('hovered');
			$(this).parents('.location').removeClass('active');
		}, 2000);
	});

	$('.map-marker').on("mouseleave", function () {
		$('.map-marker').removeClass('hovered');
	});

	$('.map-marker').on("click", function() {
		$('.map-marker').removeClass('active');
		$('.venue-card').removeClass('highlighted');
		var venue_related = $(this).attr('venue-related');
		$(this).addClass('active');
		$('.venue-card[venue-related=' + venue_related + ']').addClass('highlighted');

		setTimeout(
		function() {
			$('.map-marker').addClass('active');
		}, 3000);
	})

	$('.venue-card').on("mouseover", function () {
		$('.map-marker').removeClass('hovered');
		var venue_related = $(this).attr('venue-related');
		$('.map-marker[venue-related=' + venue_related + ']').addClass('hovered');

		setTimeout(
		function() {
			$('.venue-card[venue-related=' + venue_related + ']').removeClass('hovered');
			$(this).removeClass('hovered');
		}, 2000);
	});

	$('.venue-card').on("mouseleave", function () {
		$('.map-marker').removeClass('hovered');
	});


/* ====================== Form ======================  */
	$('.modal-trigger').on("click", function(e){
		e.preventDefault();
		$('body').addClass('noscroll');
		$('.form-popup').addClass('active');

		if($(this).hasClass('enquire-modal-trigger')) {
			$('.inner-modal[data-related="general-enquiry"]').show();

			if($(this).hasClass('offers-trigger')) {
				var offerText = $('h1').text();
				var enquiryMessage = 'I want to know more about ' + offerText;
				var relatedVenue = $(this).attr('related-venue');
				$('.inner-modal').addClass('offers-modal');
				$('#input_3_24').val('109').trigger('change');
				$('#input_3_13').val(enquiryMessage).text(enquiryMessage);
				$('#input_3_23 option').filter(function() {
					return $(this).text() === relatedVenue;
				}).prop('selected', true);
			}
		}

		if($(this).hasClass('brochure-modal-trigger')) {
			$('.inner-modal[data-related="brochure"]').show();
		}

		if($(this).hasClass('visit-modal-trigger')) {
			var venueTitle = $('.single-venue-masthead h1').text();
			$('.inner-modal').find('.venue-name').text(venueTitle);
			$('.inner-modal[data-related="book-a-visit"]').show();
		}

		if($(this).hasClass('review-modal-trigger')) {
			$('.inner-modal[data-related="reviews"]').show();
		}
	});

	$('.form-popup .close').on("click", function(e){
		var formID = $(this).parents('.form-popup').find('form').attr('ID');
		resetGravityForm(formID);
		$('body').removeClass('noscroll');
		$('.form-popup').removeClass('active');
		$('.inner-modal').hide();
		$('.inner-modal.offers-modal').removeClass('offers-modal');
	});

    $(document).on("mousedown", function(e) {
        var $formPopup = $('.form-popup');
        if ($formPopup.hasClass('active')) {
        	var formID = $($formPopup).find('form').attr('ID');

            // If the click target is NOT inside .modal OR a descendant of .modal
            if ($(e.target).closest('.modal').length === 0 && $(e.target).closest('.form-popup').length > 0) {
                resetGravityForm(formID);
                $('body').removeClass('noscroll');
                $formPopup.removeClass('active');
                $('.inner-modal').hide();
            }
        }
    });


/* ====================== Splitlines ======================  */
	// const text = new SplitType('.bg', { types: 'lines' })
	// text.lines

	// const italicText = new SplitType('.single-venue-masthead em a', { types: 'lines' })
	// italicText.lines

	// const relatedItalicText = new SplitType('.related-venue-strip em', { types: 'lines' })
	// relatedItalicText.lines

/* ====================== Sort Years Date Dropdown ======================  */
	var selectList = $('.gfield_date_dropdown_year option');
	selectList.sort(function(a,b){
		a = a.value;
		b = b.value;
		return a-b;
	});
	$('.gfield_date_dropdown_year select').html(selectList);
	$('.gfield_date_dropdown_year select option[value=2024]').prop('selected', true);

	$('.gfield_date_dropdown_year option:first-of-type').prop('selected', 'true');
	$('#visit-modal .gfield_date_dropdown_year option:nth-of-type(n+4)').hide();

/* ====================== Parallax Image and Title ======================  */
	gsap.utils.toArray('.parallax-image-and-title').forEach(block => {
		const h2 = block.querySelector('h2');
		if (!h2) return;

		var start = '50% 50%';
		var end = '100% 50%';

		if(windowWidth < 1024) {
			start = '20% 80%';
			end = '100% 100%';
		}

		gsap.fromTo(h2,
			{ y: 60 },
			{
				y: -60,
				ease: 'none',
				scrollTrigger: {
					trigger: block,
					start: start,
					end: end,
					scrub: true,
					markers: false,
				}
			}
		);
	});

/* ====================== STICKY KIT TRANSITION ======================  */
	let sticky_kit_transition = gsap.utils.toArray('.sticky-cta-bar');
		sticky_kit_transition.forEach((item, index) => {
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.reviews-strip',
				once: false,
				start:"50% 50%",
				toggleActions:"restart none none reset",
				end: "500",
				//markers: true,
			},
		});
		tl.to(item, {
			y: -70,
			ease: "none",
			duration: .1,
		});
	});

/* ====================== Cookiebot Function to disable for pagespeedinsights ======================  */
window.addEventListener("CookiebotOnDialogInit", function() {
	if (Cookiebot.getDomainUrlParam("CookiebotScan") === "true")
	  Cookiebot.setOutOfRegion();
  });

  /* ====================== Prevent Widows ======================  */
	document.querySelectorAll('.contact-strip p.address').forEach(p => {
		p.innerHTML = p.innerHTML.replace(/\s(\S+)\s*$/, '&nbsp;$1');
	});


/* ====================== Sticky CTA Bar======================  */
	var offset = $('header .lower-row').outerHeight();
	$(".sticky-cta-bar").stick_in_parent({
		offset_top: offset,
	});

/* ====================== Reset Gravity Form on Modal Close ======================  */
	function resetGravityForm(formId) {
		const form = document.getElementById(formId);
		if (!form) return;

		// Reset field values
		form.reset();

		// Remove GF validation classes from fields
		form.querySelectorAll('.gfield_error').forEach(el => {
			el.classList.remove('gfield_error');
		});

		// Remove validation messages
		form.querySelectorAll('.validation_message').forEach(el => {
			el.remove();
		});


		// Remove the top-level validation container
		const validationContainer = form.querySelector('.gform_validation_errors');
		if (validationContainer) {
			validationContainer.remove();
		}

		const submissionErrorContainer = document.body.querySelector('.gform_submission_error');
		if (submissionErrorContainer) {
			submissionErrorContainer.remove();
		}

		if (typeof window.gf_apply_rules === 'function') {
			gf_apply_rules(formId, [], true);
		}
	}

/* ====================== Clear Field Validation Error On Input ======================  */
	document.addEventListener('input', clearGravityFieldError);
	document.addEventListener('change', clearGravityFieldError);

	function clearGravityFieldError(e) {
		const field = e.target.closest('form[id^="gform_"] .gfield_error');
		if (!field) return;

		field.classList.remove('gfield_error');

		field.querySelectorAll('.validation_message').forEach(el => {
			el.remove();
		});
	}

/* ====================== iFrame Resize ======================  */
const iframes = iFrameResizer({
	waitForLoad: true,
	onResized: function() {
		ScrollTrigger.refresh();
	}
}, 'iframe');

/* ====================== Embedded Hero Video Resizing/ Cover ======================  */
	function throttle(func, wait, options) {
		var context, args, result;
		var timeout = null;
		var previous = 0;
		if (!options) options = {};
		var later = function() {
			previous = options.leading === false ? 0 : Date.now();
			timeout = null;
			result = func.apply(context, args);
			if (!timeout) context = args = null;
		};
		return function() {
			var now = Date.now();
			if (!previous && options.leading === false) previous = now;
			var remaining = wait - (now - previous);
			context = this;
			args = arguments;
		if (remaining <= 0 || remaining > wait) {
		if (timeout) {
			clearTimeout(timeout);
			timeout = null;
		}
		previous = now;
		result = func.apply(context, args);
		if (!timeout) context = args = null;
		} else if (!timeout && options.trailing !== false) {
			timeout = setTimeout(later, remaining);
		}
		return result;
	};
}

  // Vimeo JS
function getVideoDimensions(element) {
	var parentWidth = $(element).outerWidth();
	var parentHeight = $(element).outerHeight();
	var parentRatio = parentWidth / parentHeight;

	var videoWidth;
	var videoHeight;

	var ratio = 16 / 9;

	if (parentRatio >= ratio) {
		// fit to width
		videoWidth = parentWidth;
		videoHeight = parentWidth / ratio;
	} else {
		// fit to height
		videoHeight = parentHeight;
		videoWidth = (parentHeight / 9) * 16;
	}
	return {
		width: videoWidth,
		height: videoHeight
	};
}

if ($('.vimeo-video').length > 0) {
	$('.vimeo-video').each(function() {
		var heroBGPlayer = this;
		var containerEl = $(heroBGPlayer).parent('.hero').get(0);
		var videoDimensions = getVideoDimensions(heroBGPlayer);

		$(heroBGPlayer).css({
			'height': videoDimensions.height,
			'width': videoDimensions.width,
		});

	$(window).on('resize', throttle(function() {
		videoDimensions = getVideoDimensions(containerEl);
		$(heroBGPlayer).css({
			'height': videoDimensions.height,
			'width': videoDimensions.width,
		});
	}, 250));
});
}
/* ====================== Video Popup ======================  */
if ($('.video-block').length > 0) {
	var videoBlockVideo = document.querySelector('.video-block .background-video');
	var videoBlockBG = new Player(videoBlockVideo);
}

if ($('.video-block .popup-player').length > 0) {
	var popupIframe = document.querySelector('.video-block .popup-player');
	var fullScreenPlayer = new Player(popupIframe);

	var videoBlockBg = document.querySelector('.video-block iframe');
	var videoBlockBg = new Player(videoBlockBg);

	fullScreenPlayer.on('fullscreenchange', function(data) {
		if(data['fullscreen'] == false) {
			 fullScreenPlayer.pause();
		}
	});

	$('.video-block .background-video').each(function() {
		var $bgVideo = $(this);
		var bgPlayer = new Player(this);

		// Use flag to prevent repeated play calls
		let isPlaying = false;

		$bgVideo.closest('.video-block').on('mouseenter', function () {
			if (!isPlaying) {
				bgPlayer.play();
				isPlaying = true;
			}
		}).on('mouseleave', function () {
			bgPlayer.pause();
			isPlaying = false;
		});
	});

	$('.video-block .play-icon').on("click", function() {
		videoBlockBg.pause();
		fullScreenPlayer.setCurrentTime(0);
		fullScreenPlayer.play();
		setTimeout(function(){
			fullScreenPlayer.requestFullscreen();
		}, 100);
	})
}

window.addEventListener("message", (event) => {
	const messageData = event.data;
	console.log(messageData);

	if ((messageData['name'] == 'timeSlotSelected') || (messageData['name'] == 'scrollToForm')) {
		var dateSelected = formatSelectedDate(messageData['date']);

		setTimeout(function(){
			$('.date-selected span').text(dateSelected);
			$('.visit-calendar-container').addClass('active');
			var $formContainer = $('.form-container');
			var formContainerHeight = $formContainer.height();

			$('.visit-calendar-container').css('--form_container_height', formContainerHeight + 'px');
		}, 750);
	}

});
$('.show-calendar').on("click", function() {
	$('.visit-calendar-container').removeClass('active');
})

$('.form-popup .close').on("click", function(e){
	$('.visit-calendar-container').removeClass('active');
	$('.date-selected span').empty();

	var visitCalendar = document.getElementById('visitCalendar');
	if (visitCalendar) {
		visitCalendar.contentWindow.location = visitCalendar.src;
	}
	$('.key-container').removeClass('modalOpened');
	$('.key-container .key-item').removeClass('active');
});
});

function formatSelectedDate(isoString) {
	const date = new Date(isoString);

	let hours = date.getHours();
	const ampm = hours >= 12 ? 'pm' : 'am';
	hours = hours % 12 || 12;
	const time = date.getMinutes() === 0 ? `${hours}${ampm}` : `${hours}:${String(date.getMinutes()).padStart(2, '0')}${ampm}`;

	const day = date.getDate();
	const suffix = (day >= 11 && day <= 13) ? 'th' : ['th', 'st', 'nd', 'rd'][day % 10] || 'th';

	const month = date.toLocaleDateString('en-gb', { month: 'long' });

	return `${time}, ${day}${suffix} ${month} ${date.getFullYear()}`;
}